  <script setup>
    import { defineProps, computed} from 'vue'
    import cardItem from './cardItem.vue'
    const props = defineProps({
      items : []
    })

    const items = computed(()=> props.items)
    console.log(items)
  </script>

<template>

  <div v-if="items" class="text-white  w-full min-h-[100px] gap-3 items-center grid grid-cols-2 md:grid-cols-4">
    <cardItem v-for="itemT in items" :key="itemT.name" :item="itemT"/>
  </div>
</template>